import { TokenDecoded } from '../types';
import { Axios, AxiosPrivate } from '../utils';
import jwt_decode from 'jwt-decode';
import { navigate } from '@reach/router';
import { DEFAULT_STAGE } from '../contexts/authContext';
import { getDefaultStage, setDefaultStage } from '../utils/storage';

export default class TokenService {
  static setAuthorizationToken = (token: string): void => {
    Axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    AxiosPrivate.defaults.headers.common.Authorization = `Bearer ${token}`;

    localStorage.setItem('token', token);

    const { email, defaultStage, access, trialDaysLeft } = jwt_decode<TokenDecoded>(token);
    localStorage.setItem('email', email);
    getDefaultStage() ? null : setDefaultStage(defaultStage || DEFAULT_STAGE);
    localStorage.setItem('access', access || 'COLLECTION');
    localStorage.setItem('trialDaysLeft', String(trialDaysLeft));

    window.dispatchEvent(new CustomEvent('trialDaysLeftUpdated', { detail: { trialDaysLeft } }));
  };

  static clearAuthorizationToken = (): void => {
    Axios.defaults.headers.common.Authorization = '';
    AxiosPrivate.defaults.headers.common.Authorization = '';

    localStorage.removeItem('token');
    localStorage.removeItem('email');
    navigate(`/login`);
  };
}
